import { LOADING_STARTS, LOADING_STOPS } from "../../../services/types/LoadingTypes";
import { SCHEDULE_SUCCESS } from "../../../services/types/SchedulerTypes";


const initialState = {
  token: '',
  date_a: null,
  date_h:null,
  items: [],
  isLoading: false,
  load: false,
};

const scheduleReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOADING_STARTS:
      return {
        ...state,
        isLoading: true,
        load: true,
      };

    case SCHEDULE_SUCCESS:
      return {
        ...state,
        token: payload.token,
        date_a: payload.date_a,
        date_h: payload.date_h,
        items: payload.items,
        isLoading: false,
        load: false,
      };

    case LOADING_STOPS:
      return {
        ...state,
        isLoading: false,
        load: false,
      };

    default:
      return state;
  }
};

export default scheduleReducer;
